import Handler from "../Handler";

class PlayerStatsOnDemand extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processOnDemandPlayerStats(receivedData);
  }
}

export default PlayerStatsOnDemand;
